import { useState } from "react";

export const CustomTooltipCell = ({ text, limit = 60 }) => {
  const [show, setShow] = useState(false);

  if (!text) return null;

  const isLong = text.length > limit;
  const displayText = isLong ? text.slice(0, limit) + "..." : text;

  return (
    <div
      style={{ position: "relative", cursor: isLong ? "pointer" : "default" }}
      onMouseEnter={() => isLong && setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {displayText}

      {show && (
        <div
          style={{
            position: "absolute",
            bottom: "120%",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#222",
            color: "#fff",
            padding: "8px 10px",
            borderRadius: "6px",
            fontSize: "12px",
            whiteSpace: "normal",
            width: "250px",
            zIndex: 1000,
            boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};
